"use client";
/* eslint-disable no-unused-vars */

import { Button } from "@/components";
import { getImageURL } from "@/lib";

export const SpaceDivision = ({ data = {} }) => {
    return <>
        <div className="common__space">

        </div>
    </>;
};
